import React from "react";
import { NavLink } from "react-router-dom";
import * as S from "./styles";

class Navigation extends React.Component {
  state = {
    isOpen: false,
  };

  componentDidMount() {
    document.addEventListener("click", this.onDocumentClick);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.onDocumentClick);
  }

  onDocumentClick = (e) => {
    if (this._el && !this._el.contains(e.target)) {
      this.setState({
        isOpen: false,
      });
    }
  };

  close = () => {
    this.setState({
      isOpen: false,
    });
  };

  onToggleClick = (e) => {
    e.preventDefault();
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  render() {
    const pages = this.props.pages.filter(
      (o) => o.uri !== "works" && o.uri !== "home"
    );
    if (pages.length === 0) return null;
    return (
      <S.Navigation
        ref={(c) => {
          this._el = c;
        }}
      >
        <S.NavigationDrawer open={this.state.isOpen}>
          {pages.map((page) => {
            return (
              <div key={page.uri}>
                <NavLink to={`/${page.uri}`} onClick={this.close}>
                  {page.title}
                </NavLink>
              </div>
            );
          })}
        </S.NavigationDrawer>
        <S.NavigationToggle
          onClick={this.onToggleClick}
          open={this.state.isOpen}
        >
          <svg width="28px" height="28px" viewBox="0 0 28 28">
            <line x1="0" y1="6" x2="28" y2="6" />
            <line x1="0" y1="14" x2="28" y2="14" />
            <line x1="0" y1="14" x2="28" y2="14" />
            <line x1="0" y1="22" x2="28" y2="22" />
          </svg>
        </S.NavigationToggle>
      </S.Navigation>
    );
  }
}

export default Navigation;
